<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section operations">
        <div class="triggers">
          <div>
            <el-button v-if="!isEdit" type="primary" @click="editCustomEvent">{{ $t('SystemMaintenance.Edit') }}</el-button>
            <el-button v-if="!isEdit" type="danger" @click="delRuleEvent">{{ $t('SystemMaintenance.DeleteConfiguration') }}</el-button>
            <el-button v-if="isEdit" type="primary" @click="saveCustomEvent">{{ $t('SystemMaintenance.Save') }}</el-button>
            <el-button v-if="isEdit" type="default" @click="cancelCustomEvent">{{ $t('SystemMaintenance.Cancel') }}</el-button>
          </div>
        </div>
      </div>
      <div class="form-column">
        <div class="form-config-more">
          <span class="title">{{ $t('SystemMaintenance.CustomerList') }}</span>
          <el-form label-width="100px" label-position="left" :disabled="!isEdit">
            <el-form-item :label="$t('SystemMaintenance.EnterpriseType')">
              <el-select v-model="form.propertyType" style="width: 200px">
                <el-option
                  v-for="item in propertyDownlist"
                  :key="item.code"
                  :label="item.chineseName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <template slot="label">
                <label style="font-weight: normal">{{ $t('SystemMaintenance.ConditionType') }}<i class="el-icon-question" :title="$t('SystemMaintenance.SelectServiceEnabledSelectEffect')" /></label>
              </template>
              <el-select v-model="form.pushCondition" style="width: 200px" @change="handleChange">
                <el-option :label="$t('SystemMaintenance.All')" :value="1" />
                <el-option :label="$t('SystemMaintenance.WhiteList')" :value="2" />
                <el-option :label="$t('SystemMaintenance.BlackList')" :value="3" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div v-show="form.pushCondition !== 1" class="grid-wrapper">
        <div class="screen-btn">
          <el-button :disabled="!isEdit" type="primary" @click="addCustomerEvent">{{ $t('SystemMaintenance.Add') }}</el-button>
          <el-button :disabled="!isEdit" type="danger" @click="delCustomEvent">{{ $t('SystemMaintenance.Delete') }}</el-button>
        </div>
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="params=>{gridApi=params.api;gridApi.sizeColumnsToFit()}"
        />
      </div>
    </div>

    <!-- 新增客户弹框 -->
    <subscribe-port-push-rule-customer-dialog
      :title="$t('SystemMaintenance.SelectCustomer')"
      :visible.sync="ruleViewVisible"
      :customers="airPortDataSubscribeConfigCompanies"
      @saveCallBack="saveCallBackFunc"
      @close="ruleViewVisible=false"
    />
  </div>
</template>

<script>
import CommonState from '@/class/cargo/model/parameters/CommonState'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import * as subscribePortPushRuleApi from '@/api/sysManage/subscribePortPushRule'
import SubscribePortPushRuleCustomerDialog from '@/views/cargo/v0/SystemMaintenance/components/SubscribePortPushRuleCustomerDialog'
import { getGridSelected } from '@/utils/agGrid'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import lodash from 'lodash'

export default {
  name: 'SubscribeAirPortPushRuleView',
  components: { SubscribePortPushRuleCustomerDialog, cargoAdvanceSelect },
  data() {
    return {
      showMore: false,
      isEdit: false,
      propertyDownlist: [],
      containerLoadTypes: [],
      airPortDataSubscribeConfigCompanies: [],
      form: {
        pushCondition: 1, // 推送条件
        airPortDataSubscribeConfigCompanies: [], // 合作伙伴列表
        propertyType: 'OMS_JOB.CUSTOMER_ID'
      },
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CustomerName'),
          field: 'chineseName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BranchCMP'),
          field: 'branchId',
          width: 200,
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'code')
          }
        }
      ],
      rowData: [],
      PROPERTY_CUSTOMER_ID: null,
      pushRules: [],
      ruleViewVisible: false,
      loadingPortCodes: []
    }
  },
  created() {
    this.PROPERTY_CUSTOMER_ID = new CommonState('OMS_JOB.CUSTOMER_ID', '委托单位', 'OMS_JOB.CUSTOMER_ID')
    this.propertyDownlist.push(this.PROPERTY_CUSTOMER_ID)
    this.initData()
  },
  methods: {
    // 初始化数据
    async initData() {
      this.showMore = false
      subscribePortPushRuleApi.queryAirSubscribeConfig({}).then(res => {
        if (res.data.length > 0) {
          this.form = res.data[0]
          if (this.form.pushCondition === 2 || this.form.pushCondition === 3) {
            this.airPortDataSubscribeConfigCompanies = lodash.cloneDeep(this.form.airPortDataSubscribeConfigCompanies)
            this.airPortDataSubscribeConfigCompanies.forEach(eve => {
              eve.chineseName = eve.cmpName
            })
            this.form.airPortDataSubscribeConfigCompanies.forEach(eve => {
              eve.chineseName = eve.cmpName
              eve.actionType = 0
            })
            this.sortCmp()
          }
          this.form.propertyType = 'OMS_JOB.CUSTOMER_ID'
        } else {
          this.form.uuid = undefined
          this.form.version = undefined
          this.form.pushCondition = 1
          this.form.airPortDataSubscribeConfigCompanies = []
          this.form.propertyType = 'OMS_JOB.CUSTOMER_ID'
          this.airPortDataSubscribeConfigCompanies = []
        }
      })
    },
    getCommonStateByCode(code, arrs) {
      let foundObj = null
      for (const obj of arrs) {
        if (obj.code === code) {
          foundObj = obj
          break
        }
      }
      return foundObj
    },
    sortCmp() {
      this.applyFilter()
    },
    editCustomEvent() {
      if (!this.form.uuid) {
        this.clearData()
      }
      this.isEdit = true
    },
    // 删除配置
    delRuleEvent() {
      if (!this.form.uuid) {
        this.$message.warning(this.$t('SystemMaintenance.NoConfigurationItemsMade'))
        return
      }
      const loading = getLoading()
      const param = {
        uuid: this.form.uuid
      }
      subscribePortPushRuleApi.delAirSubscribeConfig(param).then(resp => {
        this.$message.success(this.$t('SystemMaintenance.DeletedSuccessfully2'))
        this.cancelCustomEvent()
      }).finally(() => loading.close())
    },
    // 默认数据还原
    clearData() {
      this.showMore = false
      this.form.uuid = undefined
      this.form.version = undefined
      this.form.pushCondition = 1
      this.form.airPortDataSubscribeConfigCompanies = []
      this.form.propertyType = 'OMS_JOB.CUSTOMER_ID'
      this.airPortDataSubscribeConfigCompanies = []
    },
    // 保存条件
    saveCustomEvent() {
      if (this.form.pushCondition === 2 && this.airPortDataSubscribeConfigCompanies.length < 1) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectWhiteListCustomers'))
        return
      }
      if (this.form.pushCondition === 3 && this.airPortDataSubscribeConfigCompanies.length < 1) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectBlackListCustomers'))
        return
      }
      if (this.form.pushCondition === 1 && this.airPortDataSubscribeConfigCompanies && this.airPortDataSubscribeConfigCompanies.length > 0) {
        for (const item of this.airPortDataSubscribeConfigCompanies) {
          item.actionType = 2
        }
      }
      if (this.form.pushCondition !== 1) {
        this.airPortDataSubscribeConfigCompanies.forEach(events => {
          let hasIn = false
          this.form.airPortDataSubscribeConfigCompanies.forEach(event => {
            if (events.uuid === event.uuid) {
              hasIn = true
            }
          })
          if (!hasIn) {
            events.actionType = 1
            this.form.airPortDataSubscribeConfigCompanies.push(events)
          }
        })
      }
      if (this.form.uuid) {
        // 更新
        const param = {
          uuid: this.form.uuid,
          version: this.form.version,
          pushCondition: this.form.pushCondition,
          airPortDataSubscribeConfigCompanies: this.form.airPortDataSubscribeConfigCompanies
        }
        const loading = getLoading()
        subscribePortPushRuleApi.updateAirSubscribeConfig(param).then(() => {
          this.$message.success(this.$t('SystemMaintenance.SavedSuccessfully'))
          this.isEdit = false
          if (this.form.pushCondition === 1) {
            this.rowData = []
          }
          this.initData()
        }).finally(() => loading.close())
      } else {
        // 新增
        const param = {
          pushCondition: this.form.pushCondition,
          airPortDataSubscribeConfigCompanies: this.form.airPortDataSubscribeConfigCompanies
        }
        const loading = getLoading()
        subscribePortPushRuleApi.addAirSubscribeConfig(param).then(() => {
          this.$message.success(this.$t('SystemMaintenance.SavedSuccessfully'))
          this.isEdit = false
          if (this.form.pushCondition === 1) {
            this.rowData = []
          }
          this.initData()
        }).finally(() => loading.close())
      }
    },
    cancelCustomEvent() {
      this.isEdit = false
      this.initData()
    },
    addCustomerEvent() {
      this.ruleViewVisible = true
    },
    // 弹框确认按钮事件
    saveCallBackFunc(datas) {
      this.airPortDataSubscribeConfigCompanies.forEach(eve => {
        datas = datas.filter(item => item.cmpIdx !== eve.cmpIdx)
      })
      for (const c1 of datas) {
        c1.selected = false
        this.airPortDataSubscribeConfigCompanies.push({
          uuid: c1.uuid,
          cmpIdx: c1.cmpIdx,
          branchId: c1.branchId,
          branchName: ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', c1.branchId, 'code'),
          chineseName: c1.chineseName || '',
          cmpName: c1.chineseName || '',
          cnShortName: c1.cnShortName || '',
          englishName: c1.englishName || ''
        })
      }
      this.sortCmp()
    },
    // 删除客户
    delCustomEvent() {
      if (this.airPortDataSubscribeConfigCompanies != null && this.airPortDataSubscribeConfigCompanies.length > 0) {
        const selections = getGridSelected(this.gridOptions)
        let uuidList = []
        if (selections && selections.length > 0) {
          selections.forEach(row => {
            const index = this.airPortDataSubscribeConfigCompanies.findIndex(c => c.uuid === row.uuid)
            uuidList = Array.from(this.airPortDataSubscribeConfigCompanies.filter(c => c.uuid === row.uuid), c => c.uuid)
            if (index > -1) {
              this.airPortDataSubscribeConfigCompanies.splice(index, 1)
            }
          })
          uuidList.forEach(eve => {
            this.form.airPortDataSubscribeConfigCompanies.forEach((e, index) => {
              if (eve === e.uuid) {
                e.actionType = 2
              }
            })
          })
        } else {
          this.$message.warning('请选择至少一条数据进行删除！')
        }
      }
      this.sortCmp()
    },
    applyFilter() {
      if (this.airPortDataSubscribeConfigCompanies != null && this.airPortDataSubscribeConfigCompanies.length > 0) {
        // 过滤符合条件的数据
        const rowData = this.airPortDataSubscribeConfigCompanies
        // 中英首字母混排
        this.rowData = rowData.sort((a, b) => {
          const x = a.chineseName ? a.chineseName[0] : ''
          const y = b.chineseName ? b.chineseName[0] : ''
          const reg = /[a-zA-Z0-9]/
          if (reg.test(x) || reg.test(y)) {
            if (x > y) {
              return 1
            } else if (x < y) {
              return -1
            } else {
              return 0
            }
          } else {
            return x.localeCompare(y)
          }
        })
      } else {
        this.rowData = []
      }
    },
    handleChange(val) {
      if (val === 1) {
        this.airPortDataSubscribeConfigCompanies = []
        this.form.airPortDataSubscribeConfigCompanies.forEach(eve => {
          eve.actionType = 2
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-column{
  background-color: #f0f3f8;
  padding: 10px 20px 20px;
  margin: 0;
  .el-form{
    padding-left: 20px;
    .el-select{
      width: 300px !important;
    }
  }
  > p{
    margin: 5px 20px 0 0;
    text-align: right;
    color: #409eff;
    cursor: pointer;
    user-select: none;
    display: block;
  }
  .title{
    line-height: 22px;
    font-size: 14px;
    padding-bottom: 8px;
    font-weight: bold;
    display: block;
    i{
      margin-left: 5px;
      font-size: 14px;
    }
  }
  .form-config-more{
    margin-top: 5px;
    .el-form{
      padding-left: 20px;
      /deep/ .el-radio__label{
        font-size: 12px;
      }
    }
    .el-checkbox-group{
      line-height: 28px;
      margin-left: 20px;
      label{
        &:first-of-type{
          width: 100px;
          font-weight: normal;
          display: inline-block;
        }
        &.el-checkbox{
          margin: 0 20px 0 0;
          /deep/ .el-checkbox__label{
            padding-left: 5px;
          }
        }
      }
    }
  }
}
.grid-wrapper{
  margin-top: 5px;
  background-color: #f0f3f8;
  padding: 5px;
  flex-direction: column;
  .screen-btn{
    display: block;
    margin: 5px 0 10px 30px;
    .el-button{
      margin-right: 10px;
    }
  }
}
</style>
